<button
    type="button"
    class="btn btn-secondary"
    [disabled]="isPending() || !editable()"
    (click)="perimeterRequested.emit()"
>
    {{ selectLabel() }}
</button>
@if (isPending()) {
    <span class="ms-2"
        ><i>{{ pendingLabel() }}</i></span
    >
}
@if (isSet() && !isPending()) {
    <span class="ms-2 text-success">
        <span>{{ setLabel() }}</span>
        @if (editable()) {
            <!-- Fix: the legacy markup put the click handler directly on the icon, which a
                 keyboard/screen-reader user cannot reach. Wrapping it in a real button
                 restores keyboard and assistive-tech access. -->
            <button
                type="button"
                class="btn btn-link p-0 ms-2 text-danger"
                [attr.aria-label]="clearAriaLabel()"
                (click)="perimeterCleared.emit()"
            >
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        }
    </span>
}
@if (errorText()) {
    <div class="text-danger mt-2">
        <span>{{ errorText() }}</span>
    </div>
}
